import React, { useState } from 'react';
import {Button, Form, Modal} from 'semantic-ui-react';
import FormField from '../../../../components/BaseComponents';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {invokeActionRequest, invokeMassUpdateRequest} from "../../../../ducks/gridActions";
import CreateReturn from '../shippingTabs/createReturn';
import {errorMapping} from "../../../../utils/errorMapping";

const ParamsFromActions = ({ formModal, invokeMassUpdate }) => {
    const {ids, name, actionName, columns = [], open, onClose, backLoad, callbackConfirmation} = formModal;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const initialReturn = {
        order: "",
        returnCostWithoutVAT: null,
        returnType: {},
        returnReason: {},
        items: [],
        comment: "",
      
    }

    const [params, setParams] = useState({});
    const [errors, setErrors] = useState({});
    const [returnObj, setReturnObj] = useState(initialReturn);

    const handleClose = () => {
        setErrors({});
        setParams({});
        onClose();
    };
    

    const handleChange = (e, { name, value }) => {
        setParams(prev => {
            let form = {
                ...prev,
                [name]: value,
            };

            const autocompleteFields = columns.filter(
                i => i.autoComplete && Object.keys(i.autoComplete).includes(name),
            );

            if (autocompleteFields && autocompleteFields.length && value) {
                autocompleteFields.forEach(autocompleteField => {
                    form = {
                        ...form,
                        [autocompleteField.name]: value[autocompleteField.autoComplete[name]] || '',
                    };
                });
            }

            return form;
        });




        setErrors(prevErrors => prevErrors && prevErrors[name]
            ? Object.keys(prevErrors)
                .filter(i => i !== name)
                .map(i => prevErrors[i])
            : prevErrors)
    };

    const handleConfirm = () => {
        dispatch(
            invokeActionRequest({
                ids: ids,
                name: name,
                model: actionName === "fullReject" ? returnObj : params,
                actionName,
                callbackError: errors => {
                    setErrors(errorMapping(errors))
                },
                callbackSuccess: () => {
                    handleClose();
                    backLoad && backLoad();
                },
                callbackConfirmation,
            }),
        );
        
       
    };

    return (
        <Modal open={open}>
            <Modal.Header>{t('fillForm')}</Modal.Header>
            <Modal.Content scrolling={actionName === "fullReject"}>
                <Form onSubmit={handleConfirm}>
                    <div className="ui form dictionary-edit" style={{ padding: 0 }}>
                        {columns.map(column => {
                            return (
                                <FormField
                                    {...column}
                                    key={column.name}
                                    error={errors && errors[column.name]}
                                    value={params[column.name]}
                                    onChange={handleChange}
                                />
                            );
                        })}
                    </div>
                    {actionName === "fullReject" ? <CreateReturn returnObj={returnObj} orderId={ids[0]} onChange={setReturnObj}/> : null}
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={handleClose}>{t('CancelButton')}</Button>
                <Button
                    primary
                    disabled={
                        !columns.filter(i => i.isRequired).every(i => params[i.name])
                    }
                    onClick={handleConfirm}
                >
                    {t('Ok')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default ParamsFromActions;
